import React from 'react'

import styled from '@emotion/styled'
import { Box } from '@gousto-internal/citrus-react'

import { config } from './config'

import css from './ReferAFriend.css'

interface Props {
  isYourOffer: boolean
  offer: string
  theirMonthOffer?: string
  discountDuration?: string
  secondBoxDiscount?: string
}

const SecondBoxDiscountOffer = styled(Box)`
  background: #f4f7fa;
  border-radius: 4px;
  text-align: center;
  width: 50%;
`

export const Offer: React.FC<Props> = ({
  isYourOffer,
  offer,
  theirMonthOffer,
  discountDuration,
  secondBoxDiscount,
}) => {
  const offerConfig = config(theirMonthOffer, discountDuration, secondBoxDiscount)
  const title = isYourOffer ? offerConfig.youGetTitle : offerConfig.yourFriendGetsTitle
  const description = isYourOffer
    ? offerConfig.youGetDescription
    : offerConfig.yourFriendGetsDescription

  return secondBoxDiscount ? (
    <SecondBoxDiscountOffer paddingH={3} paddingV={3}>
      <div className={css.offerTitle}>{title}</div>
      <div className={css.offer}>{offer}</div>
      <div className={css.offerDescription}>{description}</div>
    </SecondBoxDiscountOffer>
  ) : (
    <section className={css.offerWrapper}>
      <div className={css.offerTitle}>{title}</div>
      <div className={css.offer}>{offer}</div>
      <div className={css.offerDescription}>{description}</div>
    </section>
  )
}
